import BaseComponent from '../../base/base_component';
import Event from '../../utils/event';
import Model from './welcome_model';
import * as WelcomeConst from './welcome_const';
import LoginButtonsComponentController from '../login_buttons/login_buttons_component_controller';
import LoggedinComponentController from '../loggedin/loggedin_component_controller';
import DOM from '../../utils/dom';
import {CLIENT_EVENTS, SYSTEM_EVENTS} from '../../events/events';
import Device from '../../utils/device/device';
import * as INTEGRATION from "../../services/integration/integration_const";

class WelcomeComponentController extends BaseComponent {
    /**
     * @static
     * @type {string}
     */
    static CLASS = WelcomeConst.WELCOME_DEFAULT_PROPERTIES.CLASS_NAME;


    /**
     * @static
     * @type {string}
     */
    static DIRECTIVE = WelcomeConst.WELCOME_DEFAULT_PROPERTIES.CLASS;


    /**
     * Root component selector.
     *
     * @type {string}
     * @private
     */
    _selector = 'cgp-welcome-component';


    /**
     * @property
     * @type {*}
     * @private
     */
    _activeComponent = null;


    /**
     *
     * @type {object|null}
     * @private
     */
    _model = null;


    /**
     *
     * @param params
     */
    init(params) {
        super.init(params);

        // Initializing welcome component model.
        this._model = Model.create(params);
        this._subscribe();
    }


    /**
     * Start the welcome component behavior.
     *
     *
     * @public
     */
    start() {
        this._state();

        // Add relevant classes to the login buttons.
        if (this._getPreLoginConfiguation()) {
            let loginBtn = this.getEl().getElementsByClassName('login_buttons_login')[0];
            let registerBtn = this.getEl().getElementsByClassName('login_buttons_register')[0];

            if (Device.isMobileNotTablet()) {
                this._addClassToElement(loginBtn, 'login_buttons_login_button_style');
                this._addClassToElement(registerBtn, 'login_buttons_login_button_style');
            } else {
                this._addClassToElement(registerBtn, 'cgp-themes-main-cta');
                this._addClassToElement(loginBtn, 'cgp-themes-secondary-cta');
            }
        }

        return this;
    }


    /**
     *
     * @returns {*}
     */
    getActiveComponent() {
        return this._activeComponent;
    }


    /**
     *
     * @private
     */
    _state() {
        if (this.serviceFactory.oAuth2Service().isAuthorized()) {
            this._changeState(LoggedinComponentController, 'loggedin');
            this.logger.debug('The user is authorized so rendering a loggedin componenet over welcome.');
            return;
        }

        //this._changeState(LoginComponentController, 'login');
        this._changeState(LoginButtonsComponentController, 'login');
        this.logger.debug('The user is unauthorized so rendering a login componenet over welcome.');
    }


    /**
     * Setter the directive element
     *
     * @param ComponentController
     * @param state
     * @returns {WelcomeComponentController}
     * @private
     */
    _changeState(ComponentController, state) {
        this.logger.debug('Change state to --> ', ComponentController.CLASS);

        if (!ComponentController) {
            this.logger.error('You are trying to get component that not exist or not initialized!');
            return this;
        }

        let params = this._model.getMapByState(state);
        let component = ComponentController.create(params);
        let componentEl = component.start().getEl();

        this.logger.silly('Ready to set child component over welcome component --> ', component);

        this
            ._setActiveComponent(component)
            .render(componentEl);

        return this;
    }



    /**
     * return the the pre login configuration.
     *
     * @public
     */
    _getPreLoginConfiguation() {
        let config = {};

        switch (this._model.getPreLoginStylePC()) {
            case 'different':
                config.pc = 'cgp-themes-secondary-cta';
                break;
            case 'same':
            default:
                config.pc = 'cgp-themes-main-cta';
                break;
        }

        switch (this._model.getPreLoginStyleMobile()) {
            case 'icon':
                config.mobile = 'login_buttons_login_icon_style cgp-themes-icons-login-mobile';
                break;
            case 'button':
            default:
                config.mobile = 'login_buttons_login_button_style';
                break;
        }

        return config;
    }

    /**
     * Set active component to be over the welcome component.
     *
     *
     * @param component
     * @returns {WelcomeComponentController}
     * @private
     */
    _setActiveComponent(component) {
        if (!component) {
            this.logger.error('Not valid component --> ', component);
            return this;
        }

        this._clear();
        this._activeComponent = component;

        return this;
    }

    _subscribe() {
        Event.on(SYSTEM_EVENTS.OAUTH_STATE_CHANGE, () => {
           this.start();
        });
        Event.on(SYSTEM_EVENTS.ELEMENT_CREATED, (el)=> {
            if (!el) {return;}

            if ('cgp-directive-welcome' === el.className) {
                let loginBtn = el.getElementsByClassName('login_buttons_login')[0];
                let registerBtn = el.getElementsByClassName('login_buttons_register')[0];

                if (!loginBtn || !registerBtn) {
                    return;
                }

                let loginBtnDimensions = DOM.getDimensions(loginBtn);
                let registerBtnDimensions = DOM.getDimensions(registerBtn);

                if (!loginBtnDimensions || !registerBtnDimensions) {
                    return;
                }

                let maxWidth, classToChange;

                if (loginBtnDimensions.width < registerBtnDimensions.width) {
                    maxWidth = registerBtnDimensions.width;
                    DOM.injectStyleToDOM(loginBtnDimensions.className + ': { width: ' + maxWidth + '}');
                    classToChange = 'login_buttons_login';
                } else if (loginBtnDimensions.width > registerBtnDimensions.width) {
                    maxWidth = loginBtnDimensions.width;
                    classToChange = 'login_buttons_register';
                } else {
                    return;
                }

                DOM.injectStyleToDOM('.' + classToChange + '{ width: ' + maxWidth + 'px }');
            }
        });

        this.onSystemEvent(SYSTEM_EVENTS.INCOMING_MARKETING_FLOW, action => {
            if (action === INTEGRATION.MARKETING_FLOWS.REGISTER) {
                this._sendAnalytics('SignUp');
            }
        });

        this.onSystemEvent(CLIENT_EVENTS.LOGIN_BUTTON_CLICKED, () => {
            this._sendAnalytics('LogIn');
        });
    }


    _sendAnalytics(label) {
        let analyticObj = {
            category: 'Navigation',
            action: 'Header',
            label: label
        };
        Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, analyticObj);
    }


    _addClassToElement(elem, className) {
        if (!className || !elem) {
            return;
        }

        elem.className += ' ' + className;
    }


    /**
     * Clear events from current active component.
     *
     *
     * @returns {*}
     * @private
     */
    _clear() {
        if (!this._activeComponent) {
            return;
        }
        this._activeComponent.shutDown();
    }

    shutDown() {
        super.shutDown();
        this._clear();
    }
}

export default WelcomeComponentController;